import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { ConcessaoVeiculoSituacao } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-veiculo-situacao.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ConcessaoVeiculoDTO } from '../../../../../../model/dtos/mob/concessao-veiculo.dto';
import { ConcessaoVeiculoSearch } from '../../../../../../services/mob/concessao-veiculo.search';
import { ConcessaoVeiculoService } from '../../../../../../services/mob/concessao-veiculo.service';

@Component({
  selector: 'autocomplete-placa',
  templateUrl: './autocomplete-placa.component.html',
  styleUrls: ['./autocomplete-placa.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class AutocompletePlacaComponent implements OnInit {
  cdConcessaoVeiculo
  formGroup: FormGroup;
  concessaoVeiculos: ConcessaoVeiculoDTO[]
  filteredOptions: ConcessaoVeiculoDTO[]
  nrPlacaControl: FormControl;

  constructor(
    private _control: ControlContainer,
    private _concessaoVeiculoService: ConcessaoVeiculoService
  ) { }

  ngOnInit() {
    let filtro: ConcessaoVeiculoSearch = new ConcessaoVeiculoSearch({tpConcessao: ConcessaoTipo.TAXI})
    this.nrPlacaControl = new FormControl('')
    this.formGroup = this._control.control as FormGroup;

    this.load(filtro)

    this.formGroup.get('cdConcessao').valueChanges.subscribe(async (value) => {
      this.load(new ConcessaoVeiculoSearch({cdConcessao:value, tpConcessao: ConcessaoTipo.TAXI, stConcessaoVeiculo: ConcessaoVeiculoSituacao.VINCULADO})) 
    })


    this.nrPlacaControl.valueChanges.subscribe(value => {
      if (value != '') {
        this.filteredOptions = this._filter(value)
      } else {
        this.filteredOptions = this.concessaoVeiculos
      }
    });

  }

  private _filter(value: string): ConcessaoVeiculoDTO[] {
    const filterValue = value.toUpperCase();

    return this.concessaoVeiculos.filter(option => option.veiculo.nrPlaca.toString().toUpperCase().indexOf(filterValue) === 0);
  }

  mudaCdConcessaoVeiculo(valor) {
    if (this.formGroup.get('cdConcessaoVeiculo')) {
      this.formGroup.get("cdConcessaoVeiculo").setValue(valor ? valor.concessaoVeiculo.cdConcessaoVeiculo : null)
    }

    if (this.formGroup.get("cdVeiculo")) {
      this.formGroup.get("cdVeiculo").setValue(valor ? valor.concessaoVeiculo ? valor.concessaoVeiculo.cdVeiculo : valor.cdVeiculo : null)
    }
  }

  limparFormControl() {
    this.nrPlacaControl.setValue('')
  }

  async load(filtro: ConcessaoVeiculoSearch) {
    
    this.concessaoVeiculos = await this._concessaoVeiculoService.findConcessaoVeiculos(filtro)
    if (this.formGroup.get('cdVeiculo') && this.formGroup.get('cdVeiculo').value) {
      this.concessaoVeiculos.map(value =>{
        if(value.cdVeiculo == this.formGroup.get('cdVeiculo').value){
          this.nrPlacaControl.setValue(value.veiculo.nrPlaca)
        }
      })
    }
    this.filteredOptions = this.concessaoVeiculos
  }
}
